import React from "react";
import TicketHistory from "@components/Tickets/TicketHistory";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const HistoryPage = () => {

    return (
        <VersionedLayout>
            <TicketHistory />
        </VersionedLayout>
    );
};

export default HistoryPage;
